"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Benefits = void 0;
require("../../../../scss/progressBar.scss");
const react_1 = __importDefault(require("react"));
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const BenefitsList_1 = require("./BenefitsList");
const react_i18next_1 = require("react-i18next");
const constants_1 = require("../../../../constants");
const Button_1 = require("../../../common/Button");
const Benefits = ({ cmsInformation, onOpenProAccountClick }) => {
    var _a;
    const { currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    return (react_1.default.createElement("div", { className: "boutik-customer-account-benefits-container" },
        react_1.default.createElement("h1", { className: "boutik-customer-account-benefits-title" }, (_a = cmsInformation === null || cmsInformation === void 0 ? void 0 : cmsInformation.title) === null || _a === void 0 ? void 0 : _a[currentLocale]),
        react_1.default.createElement("div", { className: "boutik-customer-account-benefits-content" },
            react_1.default.createElement(BenefitsList_1.BenefitsList, { cmsInformation: cmsInformation }),
            react_1.default.createElement(Button_1.Button, { classNamePrefix: "boutik-customer-account-benefits", onClick: onOpenProAccountClick, label: t("createMfpProCustomerAccount.button.openProAccount") }))));
};
exports.Benefits = Benefits;
//# sourceMappingURL=Benefits.js.map